import {
  ExternalTransfer,
  ExternalTransferApiStatus,
  ExternalTransferStatus,
} from '../types/api';

const COMPLETED_STATUSES = new Set([
  'approved',
  'completed',
  'completado',
  'completada',
  'aprobado',
  'aprobada',
]);

const PENDING_STATUSES = new Set(['pending', 'pendiente', 'processing', 'en_proceso']);

export const normalizeExternalTransferStatus = (status?: string | number): ExternalTransferStatus => {
  if (typeof status === 'number') {
    return status === 1 ? 'completed' : 'pending';
  }

  const normalized = status?.toLowerCase().trim();
  if (!normalized) {
    return 'pending';
  }
  if (COMPLETED_STATUSES.has(normalized)) {
    return 'completed';
  }
  if (PENDING_STATUSES.has(normalized)) {
    return 'pending';
  }
  return 'pending';
};

export const readTransferStatusFromApi = (transfer: Record<string, unknown>): string => {
  const candidate =
    transfer.status ??
    transfer.estado ??
    transfer.state ??
    transfer.transfer_status ??
    transfer.transferStatus;

  if (typeof candidate === 'number') {
    return candidate === 1 ? 'completed' : 'pending';
  }
  return typeof candidate === 'string' ? candidate : 'pending';
};

export const readTransferIdFromApi = (transfer: Record<string, unknown>): string => {
  const candidate = transfer.id ?? transfer.transfer_id ?? transfer._id;
  if (typeof candidate === 'string') {
    return candidate;
  }
  if (typeof candidate === 'number') {
    return String(candidate);
  }
  return '';
};

export const getTransferUiStatus = (transfer: ExternalTransfer): ExternalTransferStatus =>
  normalizeExternalTransferStatus(transfer.rawStatus ?? transfer.status);

export const canCompleteExternalTransfer = (transfer: ExternalTransfer): boolean =>
  getTransferUiStatus(transfer) === 'pending';

/** Orden de intentos al guardar (compatibilidad backends legacy con `approved`) */
export const apiStatusCandidatesForUi = (
  uiStatus: ExternalTransferStatus
): ExternalTransferApiStatus[] =>
  uiStatus === 'pending' ? ['pending'] : ['completed', 'approved'];

